import React from 'react'
import { Divider, Typography } from '@material-ui/core'

import { FilterProps } from './types'

export const FilterHeader = (props: FilterProps) => {
  const { label } = props
  return (
    <>
      <Typography variant="h6">{label}</Typography>
      <Divider />
    </>
  )
}
